module.exports = __webpack_public_path__ + "static/media/uparrowsvg.a9186b8b.svg";